"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CaretRight = _interopRequireDefault(require("../../Icons/CaretRight"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

var _ThemeComponent = _interopRequireDefault(require("../../Theme/ThemeComponent"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var themeProps = {
  iconComponent: {
    name: "COMPONENT_LINK_LIST_ITEM_ICON",
    description: "",
    type: _themeContants.themePropTypes.component
  },
  icon: {
    name: "LINK_LIST_ITEM_CARET",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  listItem: {
    name: "LINK_LIST_ITEM",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  itemButton: {
    name: "LINK_LIST_ITEM_BUTTON_STYLE",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  link: {
    name: "LINK_LIST_ITEM_BUTTON",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  hover: {
    name: "LINK_LIST_ITEM_BUTTON_HOVER_ICON",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var IconComponent = function IconComponent(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: themeProps.iconComponent,
    fallback: _CaretRight["default"]
  }, props));
};

var LinkListItem = function LinkListItem(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      onClick = _ref2.onClick,
      to = _ref2.to;
  return _react["default"].createElement(ListItem, {
    className: className
  }, _react["default"].createElement(Button, {
    onClick: onClick && onClick,
    href: to
  }, children, " ", _react["default"].createElement(Cursor, null)));
};

LinkListItem.defaultProps = {
  className: ""
};
LinkListItem.propTypes = {
  to: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].any.isRequired,
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
LinkListItem.themeProps = themeProps;
var Cursor = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "LinkListItem__Cursor",
  componentId: "sc-2xlxnt-0"
})(["fill:", ";position:absolute;right:", ";", ";"], _theming.color.wcag, _theming.spacing.small, (0, _theming.applyVariants)(themeProps.icon));

var ListItem = _styledComponents["default"].li.withConfig({
  displayName: "LinkListItem__ListItem",
  componentId: "sc-2xlxnt-1"
})(["list-style:none;border-bottom:1px solid ", ";position:relative;&:last-child{border-bottom:none;}", ";"], _theming.color.line, (0, _theming.applyVariants)(themeProps.listItem));

var ButtonStyle = (0, _styledComponents.css)(["text-decoration:none;color:black;font-size:", ";font-family:", ";padding:", " ", " ", " ", ";display:block;font-weight:", ";display:flex;justify-content:space-between;align-items:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;cursor:pointer;", ";"], _theming.font.base, _theming.fontFamily.body(), _theming.spacing.small, _theming.spacing.large, _theming.spacing.small, _theming.spacing.medium, _theming.fontWeight.normal, (0, _theming.applyVariants)(themeProps.itemButton));

var Button = _styledComponents["default"].a.withConfig({
  displayName: "LinkListItem__Button",
  componentId: "sc-2xlxnt-2"
})(["", ";&:hover,&:focus{", "{fill:", ";", ";}}", ";"], ButtonStyle, Cursor, _theming.color.primary, (0, _theming.applyVariants)(themeProps.hover), (0, _theming.applyVariants)(themeProps.link));

var _default = LinkListItem;
exports["default"] = _default;